import React from 'react';

import PropTypes from 'prop-types';

const PageBack = ({ onClick, onKeyDown }) => (
    <a
        id="page-back"
        type="button"
        className="ml-pagination-numbers pg-back"
        title="Previous Page"
        aria-label="Previous Page"
        tabIndex={0}
        onClick={onClick}
        onKeyDown={onKeyDown}
    >
        <span>...</span>
        <span className="d-none"> Previous Page</span>
    </a>
);

PageBack.propTypes = {
    onClick: PropTypes.func.isRequired,
    onKeyDown: PropTypes.func.isRequired,
};

export default PageBack;

